/* eslint-disable @typescript-eslint/no-explicit-any */

import { isSSR } from "./default";

export const storeLocalStorageData = (key: string, value: any): void => {
  if (!key) {
    console.error("Key is required to store data in local storage");
  } else if (value === undefined || value === null) {
    console.error(
      `Value is of ${value} is passed Please pass proper value  to store data in local storage`,
    );
    return;
  } else if (!isSSR()) {
    const stringifiedValue = JSON.stringify(value);
    localStorage.setItem(key, stringifiedValue);
  }
};

export const storeSessionStorageData = (key: string, value: any): void => {
  if (!key) {
    console.error("Key is required to store data in session storage");
  } else if (value === undefined || value === null) {
    console.error(
      `Value is of ${value} is passed Please pass proper value  to store data in session storage`,
    );
    return;
  } else if (!isSSR()) {
    const stringifiedValue = JSON.stringify(value);
    sessionStorage.setItem(key, stringifiedValue);
  }
};

export const getLocalStorageData = (key: string): any => {
  if (!key) {
    console.error("Key is required to get data from local storage");
  } else if (!isSSR()) {
    const value = localStorage.getItem(key);
    try {
      return value ? JSON.parse(value) : null;
    } catch {
      return null;
    }
  }
};

export const getSessionStorageData = (key: string): any => {
  if (!key) {
    console.error("Key is required to get data from session storage");
  } else if (!isSSR()) {
    const value = sessionStorage.getItem(key);
    try {
      return value ? JSON.parse(value) : null;
    } catch {
      return null;
    }
  }
};

export const removeSessionStorageData = (key: string): void => {
  if (!key) {
    console.error("Key is required to remove data from session storage");
  } else if (!isSSR()) {
    sessionStorage.removeItem(key);
  }
};

export const removeLocalStorageData = (key: string): void => {
  if (!key) {
    console.error("Key is required to remove data from local storage");
  } else if (!isSSR()) {
    localStorage.removeItem(key);
  }
};
